import $ from "jquery"
// const assets_domain = "http://127.0.0.1:8000/assets"
const assets_domain = "https://assets.arabonline.cn/assets"

function request(path, params, contentType) {

    if (contentType == "application/json") {
        params = JSON.stringify(params)
    }
    
    return new Promise((resolve, reject)=>{
        let vo = {
            url: assets_domain + path,
            type: "POST",
            timeout: 600000,
            data: params,
            success: (data) => {
                resolve(data);
            },
            error: (e) => {
                reject(e.responseJSON)
            }
        }
        if (contentType != null) {
            vo.contentType = contentType;
        }
        
        $.ajax(vo) 
        
    })
}

export default {
    async searchAssets(form) {
        return request("/inv/query_assets", { ...form })
    },
    async queryAssets(query_type, width, height) {
        return request("/inv/get_assets", { query_type, width, height })
    }
}